import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=482fe5f8&"
import script from "./Invoices.vue?vue&type=script&lang=ts&"
export * from "./Invoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482fe5f8')) {
      api.createRecord('482fe5f8', component.options)
    } else {
      api.reload('482fe5f8', component.options)
    }
    module.hot.accept("./Invoices.vue?vue&type=template&id=482fe5f8&", function () {
      api.rerender('482fe5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/Invoices.vue"
export default component.exports